<template>
  <QImage2 :relativePath="relativePath" :size="size" :fallbackIcon="'$customer_group'" :openPickerOnClick="editable"
    :editable="editable" @File="file => $emit('File', file)">
  </QImage2>
</template>

<script>
import QImage2 from "@/components/QImage2.vue";

export default {
  name: "CustomerGroupImage",
  props: {
    size: Number,
    relativePath: String,
    editable: Boolean,
  },
  components: {
    QImage2,
  },
  mixins: [],

  data() {
    return {
      path: null,
      imgLoadError: false,
      uploadFile: null,
    };
  },

  mounted() {

  },

  methods: {},

  computed: {},

  watch: {},
};
</script>